/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
export * from './report-module.model';
export * from './download-module-options.model';
